import type { ReactNode } from 'react';
import type { ComparisonProduct } from './types';
import Value from './_Value';
import { classNames } from '@repo/ui/src/utils/classNames';

export interface Props {
  attribute?: string;
  shortDescription?: string;
  salesforceField?: string;
  commerceField?: string;
  products: Array<ComparisonProduct>;
  selectedSkus: Array<string>;
  asContentRow?: boolean;
  renderTooltip?: (text: string) => ReactNode;
}

const Attribute = ({
  attribute,
  shortDescription,
  salesforceField,
  commerceField,
  products,
  selectedSkus,
  asContentRow,
  renderTooltip,
}: Props) => {
  const fieldKey = commerceField ?? salesforceField;
  return (
    <tr className="attribute-row block border-b-warm-200 border-b last:border-b-0 md:grid md:grid-cols-[minmax(0,1fr),minmax(0,3fr)] items-center [&_svg]:!m-t-0">
      <th className="flex [&_span]:self-center" scope="row">
        <p className="text-neutral-600 tra-text-web-body-l font-bold py-4 sticky left-0 pl-6 text-left">
          {attribute}
        </p>
        {shortDescription && renderTooltip?.(shortDescription)}
      </th>
      <td
        className={classNames(
          'py-4 grid md:grid-cols-3 items-center justify-center gap-6 pl-8 md:pl-0 w-full',
          asContentRow ? 'grid-cols-2' : 'grid-cols-[minmax(0,1fr),minmax(0,1fr)]',
        )}
        style={{
          gridTemplateColumns: `repeat(${selectedSkus.length}, minmax(0, 1fr))`,
        }}
      >
        {fieldKey &&
          selectedSkus.map((sku, i) => {
            const { customFields } =
              products.find(({ sku: productSku }: { sku: string }) => sku === productSku) || {};
            const salesforceValue = customFields?.[fieldKey] as string | boolean | undefined;

            return (
              <div className="grid w-full items-center justify-center text-center" key={i}>
                {!!sku && <Value salesforceValue={salesforceValue} />}
              </div>
            );
          })}
      </td>
    </tr>
  );
};

export default Attribute;
